import { useCallback, useState } from 'react';
import type { SetURLSearchParams } from 'react-router';
import { createSearchParams } from 'react-router';

import type { SearchParamsState } from './useGQLSearch.ts';

function withPageResetOnFilterChange(
  previous: URLSearchParams,
  next: URLSearchParams
) {
  const keys = new Set([...previous.keys(), ...next.keys()]);
  const filtersChanged = [...keys].some(
    key =>
      key !== 'p' &&
      previous.getAll(key).join(',') !== next.getAll(key).join(',')
  );

  if (filtersChanged) {
    next.delete('p');
  }
  return next;
}

export function useInMemorySearchParams(): SearchParamsState {
  const [searchParams, setSearchParams] = useState(() => new URLSearchParams());

  const setInMemorySearchParams = useCallback<SetURLSearchParams>(nextInit => {
    setSearchParams(previous => {
      const next = createSearchParams(
        typeof nextInit === 'function'
          ? nextInit(new URLSearchParams(previous))
          : nextInit
      );
      return withPageResetOnFilterChange(previous, next);
    });
  }, []);

  return [searchParams, setInMemorySearchParams];
}
